import { Suspense } from 'react';

import { SuperBanner as SuperBannerData } from 'services/freeform';

import { useUserStore } from 'stores/use-user-store';

import CardFeatured from 'core/generic/components/cards/card-featured';

import styles from './super-banner.module.scss';

type SuperBannerProps = {
	data: SuperBannerData;
};

export const SuperBanner = ({ data }: SuperBannerProps) => {
	const href = data.link?.url || '#';
	const title = data.link?.name || data.subHeading || 'Featured';
	const target =
		data.link?.target === '_blank' || data.link?.target === '_self'
			? data.link.target
			: undefined;
	const isUserLoggedIn = useUserStore((state) =>
		Boolean(state.user?.isLoggedIn)
	);

	return (
		<section className={styles.root}>
			<div className={`container ${styles.container}`}>
				<Suspense fallback={<a href={href}>{title}</a>}>
					<CardFeatured
						url={href}
						title={title}
						caption={data.subHeading}
						image={{
							url: data.image?.url || '',
							alt: data.image?.alt || title,
						}}
						showVideoButton={Boolean(data.includeVideoIcon)}
						target={target}
						signInRequired={Boolean(data.isSignInRequired)}
						premiumVideo={Boolean(data.isPremium)}
						isUserLoggedIn={isUserLoggedIn}
					/>
				</Suspense>
			</div>
		</section>
	);
};

export default SuperBanner;
